
import { Component, Mixins } from 'vue-property-decorator';
import { VuetifyMixin } from '../../mixins';

@Component
export default class SchoolSearchSvg extends Mixins(VuetifyMixin){
}
